<div class="cartInpost">
  <div class="cartInpost_map" [hidden]="!showInpostMap">
    <div id="easypack-map"></div>
    <p class="cartInpost_error" *ngIf="error" scroll-to="cartDeliveryPayment_delivery">
      {{"cart.inpost.error.text" | translate}}
    </p>
  </div>
  <div class="cartInpost_selected" *ngIf="showSelectedInpost">
    <address class="cartInpost_selected_address">
      {{'cart.inpost.pickupPoint.text' | translate}}: {{selectedInpost.name}}
      <br>{{selectedInpost.street}} {{selectedInpost.building}} <ng-container *ngIf="selectedInpost.apartment">/ {{selectedInpost.apartment}}</ng-container>
      <br>{{selectedInpost.postCode}} {{selectedInpost.town}}
    </address>
    <button (click)="newInpost()" class="cartInpost_selected_button">{{'cart.inpost.change.button.text' | translate}}</button>
  </div>
</div>
